import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import propTypes from "../../../../constants/propTypes";
import {
  showSnackNotificationAction,
  closeModalDialog,
} from "../../../../actions/layoutActions";
import {
  performDeleteRequest,
  setReload,
} from "../../../../actions/dataComponentActions";
import { processDeleteRequestStatus } from "../../../../utils/dataComponentUtils";
import { getDataComponent } from "../../../../reducers/dataComponentReducer";
import DeleteConfirmation from "../../../ui/DeleteConfirmation";

const dataComponentId = "ClientsGrid";

export class DeleteClientContainer extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    dataComponent: propTypes.dataComponent.isRequired,
    performDeleteRequest: PropTypes.func.isRequired,
    closeModalDialog: PropTypes.func.isRequired,
    showSnackNotificationAction: PropTypes.func.isRequired,
    setReload: PropTypes.func.isRequired,
  };

  componentDidUpdate({ dataComponent: prevDataComponent }) {
    const { dataComponent, closeModalDialog, setReload } = this.props;

    processDeleteRequestStatus(prevDataComponent, dataComponent, {
      onSuccess: () => {
        setReload("ClientsGrid", true);
        closeModalDialog();
      },
      onError: this.handleDeleteRequestError,
    });
  }

  handleDeleteRequestError = ({ data }) => {
    const { showSnackNotificationAction } = this.props;

    data.errors.map(error => {
      if (error.global) {
        showSnackNotificationAction(error.title);
      }
    });
  };

  deleteClient = () => {
    const { id, performDeleteRequest } = this.props;
    performDeleteRequest(dataComponentId, id);
  };

  render() {
    const { title } = this.props;
    return <DeleteConfirmation title={title} onDelete={this.deleteClient} />;
  }
}

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

const mapDispatchToProps = {
  performDeleteRequest,
  closeModalDialog,
  showSnackNotificationAction,
  setReload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteClientContainer);
